import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormControl } from '@angular/forms';
import { KundenSettingsService } from '../../profile-settings/kunden-settings/kunden-settings.service';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { EditHaendlerDialogComponent } from '../../profile-settings/kunden-settings/edit-haendler-dialog/edit-haendler-dialog.component';
import { KieneAutocompleteComponent } from '../../components/kiene-autocomplete/kiene-autocomplete.component';
import { GruppeTierService } from '../../../../projects/kiene-core/src/lib/components/gruppe-tier/gruppe-tier.service';
import { GruppeTier } from '../../../../projects/kiene-core/src/lib/components/gruppe-tier/classes/gruppe-tier';
import { Haendler } from '../../../../projects/kiene-core/src/lib/components/stammdaten/haendler/haendler';
import { Tierbemerkung } from '../../../../projects/kiene-core/src/lib/components/gruppe-tier/classes/tierbemerkung';
import { LocalStorageService } from '../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { canEditHaendler as userCanEditHaendler } from '../../../../projects/kiene-core/src/lib/components/stammdaten/haendler/haendler-permissions';

@Component({
    selector: 'kiene-tier-editieren-dialog',
    templateUrl: './tier-editieren-dialog.component.html',
    styleUrls: ['./tier-editieren-dialog.component.scss'],
})
export class TierEditierenDialogComponent implements OnInit {
    tier: GruppeTier;
    emptyListHaendler = false;
    haendlerFavoriten: Haendler[] = [];
    bemerkungen: Tierbemerkung[] = [];

    @ViewChild('bemerkungenAutocomplete')
    bemerkungenAutocomplete: KieneAutocompleteComponent;
    abteilCtrl: UntypedFormControl = new UntypedFormControl();
    haendlerCtrl: UntypedFormControl = new UntypedFormControl();
    canEditHaendler = false;

    constructor(
        public dialogRef: MatDialogRef<TierEditierenDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private readonly gruppeTierService: GruppeTierService,
        private readonly kundenSettingsService: KundenSettingsService,
        private readonly messageService: MessageService,
        private readonly dialog: MatDialog,
        private readonly localStorageService: LocalStorageService,
    ) {
        this.canEditHaendler = userCanEditHaendler(this.localStorageService);
        if (data.tier) {
            this.tier = data.tier;
            this.abteilCtrl.setValue(this.tier?.abteil);
            this.ladeHaendlerFavoriten();
        }
    }

    ngOnInit(): void {}

    compareHaendler(h1: Haendler, h2: Haendler) {
        return h1 && h2 && h1.viehhaendler_id === h2.viehhaendler_id;
    }

    updateGruppeTier() {
        this.tier.viehhaendler_id = this.haendlerCtrl.value?.viehhaendler_id;
        this.tier.abteil = this.abteilCtrl.value;
        this.gruppeTierService.update(this.tier).subscribe({
            next: resp => {
                this.tier = resp;
                this.messageService.infoMessage('Tierdaten wurden erfolgreich aktualisiert.');
                this.dialogRef.close(this.tier);
            },
            error: err => {
                this.messageService.errorMessage('Fehler beim Speichern des Tieres!', err);
            },
        });
    }

    openHaendlerVerwaltung() {
        if (!this.canEditHaendler) {
            return;
        }
        const dialogRef = this.dialog.open(EditHaendlerDialogComponent, { width: '50vw' });
        dialogRef.afterClosed().subscribe({
            next: resp => {
                if (resp) {
                    this.kundenSettingsService.addOrUpdateHaendler(resp).subscribe({
                        next: () => {
                            this.ladeHaendlerFavoriten();
                        },
                        error: err => {
                            this.messageService.errorMessage('Fehler beim Speichern des Händlers !', err);
                        },
                    });
                }
            },
        });
    }

    ladeHaendlerFavoriten() {
        this.kundenSettingsService.loadHaendlerFavoriten().subscribe(haendlerFavoriten => {
            this.haendlerFavoriten = haendlerFavoriten.records;

            if (this.tier.viehhaendler_id) {
                this.haendlerCtrl.setValue(
                    this.haendlerFavoriten.find(h => h.viehhaendler_id === this.tier.viehhaendler_id),
                );
            }

            if (this.haendlerFavoriten.length === 0) {
                this.emptyListHaendler = true;
            }
        });
    }

    add() {
        this.bemerkungenAutocomplete.emitCurrentValue();
    }
}
